export enum borderRadius {
  xs = "4px",
  s = "6px",
  m = "9px",
  l = "12px",
  xl = "15px",
}
